import { render, staticRenderFns } from "./ExternalMenuButton.vue?vue&type=template&id=a926de7e&scoped=true&"
import script from "./ExternalMenuButton.vue?vue&type=script&lang=ts&"
export * from "./ExternalMenuButton.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalMenuButton.vue?vue&type=style&index=0&id=a926de7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a926de7e",
  null
  
)

export default component.exports